const Environment = {
    apiKey: process.env.REACT_APP_API_KEY || '',
    appServiceUrl: process.env.REACT_APP_BASE_URL || '',
    languageSupport: (process.env.REACT_APP_LANGUAGE_SUPPORT || "").toString() === 'true' || false,
    canBackSupport: (process.env.REACT_APP_CAN_BACK_SUPPORT || "").toString() === 'true' || false,
    timeFormat: "HH:mm",
    dateFormat: "MM/DD/YYYY",
    dateFormatPath: "MM-DD-YYYY",
    dateFormatView: "DD/MM/YYYY",
};

export default Environment;
